import request from '@/utils/request';

export default {
  listAll(params) {
    return request({ url: 'dict/listAll', params });
  }
};
